import React, { useState } from "react";
import "./Join.css";
import { useNavigate } from "react-router-dom";
import profileImg from  "../images/b4997803-9617-42b1-a28e-06cb75f4efc7.jpg"; // placeholder — swap with your image

// Replace this import with your actual image
// import profileImg from "./assets/your-image.jpg";

const Join = () => {
  const [name, setName] = useState("");
  const navigate = useNavigate();

  const handleJoin = () => {
    if (!name.trim()) {
      alert("Please enter your name");
      return;
    }
    navigate("/chat", { state: { name } });
  };

  return (
    <div className="joinContainer">
      {/* Decorative blobs */}
      <div className="blob blob1" />
      <div className="blob blob2" />
      <div className="blob blob3" />

      <div className="joinBox">

        {/* Profile Image Circle */}
        <div className="avatarWrapper">
          <img src={profileImg} alt="Profile" className="avatarImg" />
          <span className="avatarBadge">🟢</span>
        </div>

        {/* Logo / Title */}
        <div className="logoSection">
          <h1 className="appTitle">RealTime Chat</h1>
          <p className="appSubtitle">
            Connect with friends instantly — anywhere, anytime
          </p>
        </div>

        {/* Join Form */}
        <h2 className="heading">Join a Room</h2>

        <div className="inputWrapper">
          <span className="inputIcon">👤</span>
          <input
            type="text"
            placeholder="Enter your name"
            className="joinInput"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleJoin()}
          />
        </div>

        <button className="joinButton" onClick={handleJoin}>
          <span>Join Chat</span>
          <svg className="btnArrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </button>

        {/* Divider */}
        <div className="divider"><span>Features</span></div>

        {/* Features Section */}
        <div className="featureList">
          <div className="featureItem">
            <span className="featureIcon">⚡</span>
            <span>Real-time Messaging</span>
          </div>
          <div className="featureItem">
            <span className="featureIcon">📷</span>
            <span>Image Sharing</span>
          </div>
          <div className="featureItem">
            <span className="featureIcon">📹</span>
            <span>Video Calling</span>
          </div>
          <div className="featureItem">
            <span className="featureIcon">🔒</span>
            <span>Secure Connection</span>
          </div>
        </div>

        {/* Footer */}
        <div className="joinFooter">
          <p>Start chatting with people around the world 🌍</p>
        </div>

      </div>
    </div>
  );
};

export default Join;